import script from "./layoutSider.vue?vue&type=script&setup=true&lang=js"
export * from "./layoutSider.vue?vue&type=script&setup=true&lang=js"

import "./layoutSider.vue?vue&type=style&index=0&id=0b09818c&lang=scss&scoped=true"

import exportComponent from "/Users/ioblabs/work/weina/production/weina_oms_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b09818c"]])

export default __exports__